import React from "react";

import {
	getCombinationStatus,
	getFormatedCombinationQuota,
	getSystemIdentifierString,
} from "@utils/my-bets/helpers";

export default function BetCombinationItem(props: {
	combination: {
		combinationStatus: number;
		combinationOffers: { systemIdentifier: string }[];
		combinationQuota: number;
	};
	ordinalNumber: string;
}) {
	return (
		<tr
			className={
				"table--primary__body__row u-color--offer--" +
				getCombinationStatus(props.combination.combinationStatus)
			}
		>
			<td className="table--primary__body__data u-type--center">
				{props.ordinalNumber}
			</td>
			<td className="table--primary__body__data u-type--center">
				{getSystemIdentifierString(props.combination.combinationOffers)}
			</td>
			<td className="table--primary__body__data u-type--center">
				{getFormatedCombinationQuota(
					props.combination.combinationQuota
				)}
			</td>
		</tr>
	);
}
